import { render, staticRenderFns } from "./term14.vue?vue&type=template&id=3b97afd6"
import script from "./term14.vue?vue&type=script&lang=js"
export * from "./term14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports